/* ==========================================================================
   ZORA — Article page: reading progress + share
   ========================================================================== */
(function () {
  'use strict';

  var article = document.querySelector('[data-z-article]');
  if (!article) return;

  /* Progress across the article body only, not the whole page */
  var bar = article.querySelector('[data-z-article-progress]');
  var body = article.querySelector('[data-z-article-body]');

  if (bar && body) {
    var ticking = false;

    function update() {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var pct = total > 0 ? Math.min(Math.max(scrolled / total, 0), 1) : 0;
      bar.style.transform = 'scaleX(' + pct + ')';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* Share / copy link */
  var shareBtn = article.querySelector('[data-z-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = shareBtn.getAttribute('data-url');
      var title = shareBtn.getAttribute('data-title');

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          if (window.Zora && window.Zora.toast) window.Zora.toast('Link copied');
        });
      }
    });
  }

  /* Wrap any table the author pasted in so it scrolls instead of overflowing */
  if (body) {
    Array.prototype.forEach.call(body.querySelectorAll('table'), function (table) {
      if (table.parentElement && table.parentElement.classList.contains('z-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'z-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }
})();
